export default __webpack_public_path__ + "static/media/justice.5d92c539.png";